/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { logout } from '~/services/auth';
import Constants from '~/utils/constants';

export enum ApiMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export class ApiHeader {
  name?: string;

  value: any;

  public constructor(init?: Partial<ApiHeader>) {
    Object.assign(this, init);
  }
}

function useApi<T>(
  url: string,
  method: ApiMethod,
  body?: any,
  headers: ApiHeader[] = [],
) {
  const [responseApi, setResponseApi] = useState({
    status: null,
    loading: false,
    error: null,
    data: null,
    success: false,
    response: null,
  });

  const callApi = (reqBody?: any) => FetchData(reqBody);

  const getOptions = (reqBody?: any) => {
    const reqHeaders: Headers = new Headers();
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    const tokenBearer = localStorage.getItem(Constants.TOKEN_BEARER);
    const tokenUUID = uuidv4().toLocaleString();
    const xcode = localStorage.getItem(Constants.XCODE_KEY);

    reqHeaders.set('Content-Type', 'application/json');
    if (token) reqHeaders.set('apikey', `token ${token}`);
    if (tokenBearer) reqHeaders.set('Authorization', `Bearer ${tokenBearer}`);
    if (headers) headers.forEach((h) => reqHeaders.append(h.name!, h.value));
    if (tokenUUID) reqHeaders.set('X-Idempotence-Key', `${tokenUUID}`);
    if (xcode) reqHeaders.set('X-Code', `${xcode}`);

    let newBody = null;

    if (body) {
      if (reqBody) {
        newBody = Object.assign(body, reqBody);
      } else {
        newBody = body;
      }
    } else if (reqBody) {
      newBody = reqBody;
    }

    let options: RequestInit = {
      method,
      headers: reqHeaders,
    };

    if (method !== ApiMethod.GET) {
      options = {
        ...options,
        body: JSON.stringify(newBody) || null,
      };
    }

    return options;
  };

  const FetchData = async (
    reqBody?: any,
  ): Promise<{
    status: number;
    data: object & T;
    response: Response;
  }> => {
    setResponseApi({ ...responseApi, loading: true });

    const options = getOptions(reqBody);

    const res = await fetch(url, options);
    const copyResponse = res.clone();

    if (res.status === 401) {
      logout();
    }

    let json = null;
    const statusResponse = res.status;

    try {
      if (res && statusResponse !== 204)
        json = await res
          .json()
          .then((data) => data)
          .catch(null);

      setResponseApi({
        loading: false,
        data: json,
        error: null,
        status: statusResponse,
        success: true,
        response: res,
      });
    } catch (e) {
      setResponseApi({
        loading: false,
        data: null,
        error: String(e),
        status: statusResponse,
        success: !!(statusResponse === 200 || 201 || 204),
        response: null,
      });
    }

    return { status: res.status, data: json, response: copyResponse };
  };

  return { callApi, ...responseApi };
}

export default useApi;
